export const PAGINATION = {
  page: 1,
  size: 25
};

export const SHAREHOLDER_TYPE = {
  1: '无效用户',
  2: '有效用户',
  3: '初级股东',
  4: '中级股东',
  5: '高级股东'
};
